export enum EventRequestTransactionItemType {
  assignment = 'assignment',
}
